import React from 'react'

import { AlertBox, AlertBoxDismissButton } from '@vp/swan'

import { useAlertState } from './contexts/AlertContext'

const AlertCollection: React.FC = () => {
  const { error, warning, success, setError, setWarning, setSuccess } = useAlertState()

  return (
    <div className="alert-collection">
      {error && (
        <AlertBox skin="error" onRequestDismiss={() => setError('')} marginX="auto">
          {error}
          <AlertBoxDismissButton visuallyHiddenLabel="Dismiss alert" />
        </AlertBox>
      )}
      {warning && (
        <AlertBox skin="warning" onRequestDismiss={() => setWarning('')} marginX="auto">
          {warning}
          <AlertBoxDismissButton visuallyHiddenLabel="Dismiss alert" />
        </AlertBox>
      )}
      {success && (
        <AlertBox skin="success" onRequestDismiss={() => setSuccess('')} marginX="auto">
          {success}
          <AlertBoxDismissButton visuallyHiddenLabel="Dismiss alert" />
        </AlertBox>
      )}
    </div>
  )
}

export default AlertCollection
